import './section-hero.scss';

import Rellax from 'Rellax';
import { TimelineLite } from 'gsap';

import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default (() => {
	if ($('.layer').length > 0) {
		if ($('.hero--single-game')) {
			toogleTitle();
			$(window).resize(function () {
				toogleTitle();
			});
		}

		const rellax = new Rellax('.layer', {
			speed: -5
		});

		if ($('.hero-rocket').length > 0) {
			const controller = new ScrollMagic.Controller();
			const rocket = $('.hero-rocket');

			// hero-rocket scene
			new ScrollMagic.Scene({
				triggerElement: '.image',
				offset: 50,
				triggerHook: '0.17'
			})
				.on('enter', e => {
					new TimelineLite()
						.to(rocket, 0.5, {
							x: 37,
							y: -70
						})
						.to(rocket, 0.3, {
							opacity: 0
						});
				})
				.on('leave', e => {
					new TimelineLite()
						.to(rocket, 0.5, {
							x: 0,
							y: 0
						})
						.to(
							rocket,
							0.3,
							{
								opacity: 1
							},
							'-=0.25'
						);
				})
			// .addIndicators()
				.addTo(controller);
		}
	}
})();

function toogleTitle () {
	const titleSingleGame = $('.hero--single-game .hero__content .title');
	if ($(window).width() < 768) {
		titleSingleGame.removeClass('title--left');
	} else if ($(window).width() >= 768) {
		titleSingleGame.addClass('title--left');
	}
}
